import { render, staticRenderFns } from "./followUp.vue?vue&type=template&id=a8a4c82e&scoped=true"
import script from "./followUp.vue?vue&type=script&lang=js"
export * from "./followUp.vue?vue&type=script&lang=js"
import style0 from "./followUp.vue?vue&type=style&index=0&id=a8a4c82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a4c82e",
  null
  
)

export default component.exports